import { render, staticRenderFns } from "./SideBarDetail.vue?vue&type=template&id=5e002f78&"
import script from "./SideBarDetail.vue?vue&type=script&lang=js&"
export * from "./SideBarDetail.vue?vue&type=script&lang=js&"
import style0 from "./SideBarDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports